module.exports = __webpack_public_path__ + "static/img/Orion Logo Grey.1b1a9d11.svg";